import { render, staticRenderFns } from "./ModuleApprover.vue?vue&type=template&id=b301989a"
import script from "./ModuleApprover.vue?vue&type=script&lang=js"
export * from "./ModuleApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports